<template>
    <div
        id="main-modal"
        :class="modal.class"
        aria-labelledby="main-modal"
        class="modal show"
        role="dialog"
        tabindex="-1"
    >
        <div
            class="modal-lg modal-dialog modal-dialog-scrollable"
            role="document"
            @click.stop
        >
            <div class="modal-content">
                <form
                    id="form-action"
                    :action="modal.action"
                    method="post"
                    role="form"
                    @submit.prevent="processModal"
                >
                    <div class="modal-header">
                        <button
                            :disabled="inProcess"
                            aria-label="Close"
                            class="close"
                            data-dismiss="modal"
                            type="button"
                            @click="close"
                        >
                            <span aria-hidden="true">
                                <i class="fa fa-times"></i>
                            </span>
                        </button>
                        <h4
                            id="main-modal-body"
                            class="modal-title"
                            v-text="modal.header"
                        ></h4>
                    </div>
                    <div class="modal-body">
                        <h4 v-if="modal.bodyHeader">{{ modal.bodyHeader }}</h4>
                        <div
                            v-if="modal.isBodyHtml"
                            v-html="modal.body"
                        ></div>
                        <p v-else-if="modal.body">{{ modal.body }}</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            v-if="!modal.denyText"
                            :disabled="inProcess"
                            class="btn btn-sm btn-default"
                            data-dismiss="modal"
                            type="button"
                            @click="close"
                        >
                            Close
                        </button>
                        <button
                            v-else
                            :disabled="inProcess"
                            class="btn btn-sm btn-default"
                            data-dismiss="modal"
                            type="button"
                            @click="close"
                        >
                            {{ modal.denyText }}
                        </button>
                        <button
                            v-if="!modal.approveText"
                            :disabled="inProcess"
                            :class="modal.btnColor ? modal.btnColor : 'btn-primary'"
                            class="btn btn-sm"
                            type="submit"
                        >
                            Confirm
                        </button>
                        <button
                            v-else
                            :class="modal.btnColor ? modal.btnColor : 'btn-primary'"
                            :disabled="inProcess"
                            class="btn btn-sm"
                            type="submit"
                        >
                            {{ modal.approveText }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '../../event-bus';

export default {
    props: {
        modal: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            inProcess: false,
            modalData: {},
        };
    },
    methods: {
        close: function () {
            this.$emit('close');
        },
        processModal: function () {
            let app = this;
            this.inProcess = true;
            axios
                .post(this.modal.action, {
                    _method: this.modal.method,
                })
                .then(function (resp) {
                    app.modalData = resp.data;
                    app.$emit('updateData', resp.data.formData);
                    EventBus.$emit('alertData', resp.data.formData);
                });
        },
    },
};
</script>
